import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import useComponent from './useComponent';
import Desktop from './desktop';
import Mobile from './mobile';

const ProductPricePage = () => {
  const isMobile = useIsMobile(768);
  const viewModel = useComponent();

  return isMobile ? <Mobile viewModel={viewModel} /> : <Desktop viewModel={viewModel} />;
};

export default ProductPricePage;
